module.exports = __webpack_public_path__ + "static/media/arrow-alt-to-right.f1cc3e6e.svg";